export default __webpack_public_path__ + "static/media/Pipe Threading.fbb9a32c.jpg";